<template>
  <!-- 
  https://docs.google.com/document/d/1jSbQkM8ltXbVCGwrXYCEk9fLi4565xjYFFekBLdhuHE/edit 
  https://app.diagrams.net/#G1CTLkntTb-ALjRbBLOovB7DgbI9ncVn1x
  https://docs.google.com/presentation/d/14HyMsdzJs2S_lKvvgV1GmViLrM1j85CSgMHZecfbOsE/edit#slide=id.g115a712aff8_0_26
  https://xd.adobe.com/view/1198946f-6b64-4afc-b49d-ef7c9bde4f25-44cb/screen/9e7c699e-5e95-4a04-8bb1-3da72be13907/
  https://xd.adobe.com/view/4038b7ca-cd16-4ce1-81a1-09136190e68a-156b/screen/ba08004b-c24d-447f-bef1-e37f0958d52f/specs/ latet
  https://docs.google.com/presentation/d/1nex8gyopKDpMVDe06ULBtf1sMtQDa90klMbSpC-FPCA/edit#slide=id.g2447b16f1cc_0_0
  -->
	<div id="signuppage" class="clearfix">
      <div id="mainbar" class="col-12 flex justify-between items-center navbarsignup app-header navbar ">
        <div class="col-5 flex-none">
          <p type="button"  class="no-hover m0 inline-block flex justify-start items-center">
            <img src="/static/svg/h.svg" alt="" height="28">
            <span class="h5 ml1 gibson darkblue mb0 semi-bold">Håndværker.dk</span>
          </p>
        </div>
        <div class="col-4 flex flex-auto m0 justify-end items-center sm-hide " style="height:inherit;">
          <span class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="332px" alt="Håndværker.dk logo" height="30px" viewBox="0 0 1215.749 97" class=" inline-block"><g id="Group_4478" data-name="Group 4478" transform="translate(15699.891 5122)"><g id="Group_4476" data-name="Group 4476" transform="translate(0 -430)"><g id="Group_4463" data-name="Group 4463" transform="translate(-70.087 125)"><rect id="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect> <path id="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path></g> <g id="Group_4466" data-name="Group 4466" transform="translate(95.913 125)"><rect id="Rectangle-path-2" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect> <path id="Shape-2" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path></g> <g id="Group_4464" data-name="Group 4464" transform="translate(12.913 125)"><rect id="Rectangle-path-3" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect> <path id="Shape-3" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path></g> <g id="Group_4465" data-name="Group 4465" transform="translate(178.913 125)"><rect id="Rectangle-path-4" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect> <path id="Shape-4" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path></g> <g id="Group_4474" data-name="Group 4474"><g id="Group_4467" data-name="Group 4467" transform="translate(261.913 125)"><rect id="Rectangle-path-5" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect> <path id="Shape-5" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path></g></g></g> <path id="Path_1237" data-name="Path 1237" d="M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z" transform="translate(-14711.953 -5101.56)"></path> <g id="Group_4477" data-name="Group 4477" transform="translate(-159.845 -438.084)"><path id="Shape-6" data-name="Shape" d="M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z" transform="translate(-14655.487 -4700.116)" fill="#00b67a"></path> <path id="Path_1234" data-name="Path 1234" d="M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z" transform="translate(12.355 14.797)" fill="#005128"></path></g> <path id="Path_1238" data-name="Path 1238" d="M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z" transform="translate(-15706 -5134)"></path></g></svg>
          </span>
        </div>
        <div class="col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide" style="height:inherit;">
          <span class="flex items-center">
        <svg class=" inline-block" xmlns="http://www.w3.org/2000/svg" width="100px" height="40px" viewBox="0 0 406 237.288">
          <g id="Fremragende_Mobile" data-name="Fremragende Mobile" transform="translate(15715 4255.242)">
          <g id="Group_4471" data-name="Group 4471" transform="translate(-477 94)">
          <g id="Group_4463" data-name="Group 4463" transform="translate(-70.087 538)">
          <rect id="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect>
          <path id="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path>
          </g>
          <g id="Group_4466" data-name="Group 4466" transform="translate(95.913 538)">
          <rect id="Rectangle-path-2" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect>
          <path id="Shape-2" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path>
          </g>
          <g id="Group_4464" data-name="Group 4464" transform="translate(12.913 538)">
          <rect id="Rectangle-path-3" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect>
          <path id="Shape-3" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path>
          </g>
          <g id="Group_4465" data-name="Group 4465" transform="translate(178.913 538)">
          <rect id="Rectangle-path-4" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect>
          <path id="Shape-4" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path>
          </g>
          <g id="Group_4467" data-name="Group 4467" transform="translate(261.913 538)">
          <rect id="Rectangle-path-5" data-name="Rectangle-path" width="74" height="72" transform="translate(-15167.913 -4817)" fill="#00b67a"></rect>
          <path id="Shape-5" data-name="Shape" d="M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z" transform="translate(-15170.4 -4821.2)" fill="#fff"></path>
          </g>
          </g>
          <path id="Path_1239" data-name="Path 1239" d="M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z" transform="translate(-15681.109 -4279.445)"></path>
          <g id="Group_4472" data-name="Group 4472" transform="translate(-838.068 181.887)">
          <path id="Path_1235" data-name="Path 1235" d="M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z" transform="translate(-14724.018 -4261.217)"></path>
          <g id="Group_4469" data-name="Group 4469" transform="translate(-14800.932 -4279)">
          <path id="Shape-6" data-name="Shape" d="M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z" transform="translate(-14.4 -16.2)" fill="#00b67a"></path>
          <path id="Path_1234" data-name="Path 1234" d="M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z" transform="translate(14648.439 4692.722)" fill="#005128"></path>
          </g>
          </g>
          </g>
          </svg>
           </span>
        </div>
      </div>
      <div id="mainbarstatus" class="col-12 flex justify-between items-center header-fixed app-header " style="">
        <div class="sm-hide" style="width: 340px;" v-if="step === 1">
        </div>
        <div class="lg-col-8 md-col-8 sm-col-12 p0 flex flex-row mr-auto items-center mobile-flex-column white justify-between" v-if="step === 1">
          <div class="mx1">
              <span class=" darkblue mb0 bold h4 my1">Aktivering</span>
          </div>
          <div class="flex h5 semi-bold m0 lg-col-8 md-col-8 sm-col-12 mmx-auto justify-end mpt1">
              <p class="flex items-center m0"><span class=" darkblue mb0 h6 semi-bold" style="padding-right: 5px;">Bud tilgængelige:</span><span class="primarycolor">{{jobstotalstatic}}</span></p>
              <p class="ml1 flex items-center m0"><span class=" darkblue mb0 h6 semi-bold mx1">Min Plan:</span>
                <button class="p1 px2 action-button sm-hide " @click="nextstep()" v-if="step === 1">Aktiver din prøveversion nu</button>
                <span class="red m0" style="font-size:.89rem" v-if="showMobile && step === 1">Din konto er ikke aktiveret</span>
                <span class="primarycolor" v-if="showMobile && step > 1">Gratis</span>
                </p>
          </div>
        </div>
        <div class="lg-col-7 md-col-7 sm-col-12 p0 flex flex-row mx-auto items-center mobile-flex-column white justify-between" style="max-width:920px" v-if="step !== 1" >
          <div class="mx1">
              <span class=" darkblue mb0 bold h4 my1">Aktivering</span>
          </div>
          <div class="flex h5 semi-bold m0 lg-col-6 md-col-6 sm-col-12 mmx-auto justify-end mpt1">
              <p class="flex items-center m0"><span class=" darkblue mb0 h6 semi-bold mr1">Bud tilgængelige:</span><span class="primarycolor">{{jobstotalstatic}}</span></p>
              <p class="ml1 flex items-center m0"><span class=" darkblue mb0 h6 semi-bold mx1">Min Plan:</span>
                <span class="primarycolor">Gratis</span>
                </p>
          </div>
        </div>
      </div>
      <div id="reminderbar" class="col-12 flex justify-center items-center hide alert alert-danger not-rounded m0 p0">
        <p class="darkblue h6 p1 m0 center">Du mangler at aktivere din gratis bruger for at modtage dine 3 gratis bud.</p>
      </div>
      <div id="button" class="lg-hide md-hide col-12 buttonsticky pointer white-background"  style="" v-if="step !== 4">
        <button class="action-button p2 not-rounded m0 col-12 " @click="nextstep()" v-if="step === 1"><p class="h5 semi-bold white m0" >Aktiver din prøveversion nu <i class="el-icon-right"></i></p></button>
        <div class="col-12 flex flex-column p1 mx-auto" v-if="step === 2">
          <button type="button" class="action-button p2 not-rounded m0 mb1  col-12" @click="updateinfo()"><p class="h5 semi-bold white m0" >Næste <i class="el-icon-right"></i></p></button>
          <button type="button" class="outlined-primary-button p2 not-rounded m0 col-12" @click="backstep()"><p class="h5 semi-bold primarycolor m0" ><i class="el-icon-back"></i> Tilbage</p></button>
        </div>
        <div class="col-12 flex flex-column p1 mx-auto" v-if="step === 3">
          <!-- <button class="action-button p2 not-rounded m0 mb1  col-12" @click="nextstep()"><p class="h5 semi-bold white m0" >Næste <i class="el-icon-right"></i></p></button> -->
          <button type="button" class="outlined-primary-button p2 not-rounded m0 col-12" @click="backstep()"><p class="h5 semi-bold primarycolor m0" ><i class="el-icon-back"></i> Tilbage</p></button>
        </div>
      </div>
      <div id="marketplace2" class="">
        <div class="sidebar">
            <div></div>
            <nav class="sidebar-nav">
                <ul class="nav">
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 semi-bold capitalletter">
                        <div>
                            <p  type="button"   class=" nav-link m0">
                                <i class="el-icon-house ml1 darkblue "></i>
                                <span class="inline-block ">Forside
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown">
                        <div id="dropBeskeder" class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-star-off mr2 darkblue"></i>
                            Beskeder</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 mr2 regular" id="messages/inbox">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Inbox
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li @click="nextstep()" class="nav-item darkblue gibson h5 mr2 regular" id="messages/sent">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Sendt
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown">
                        <div id="dropAnbefalinger" class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-star-off mr2 darkblue"></i>
                            Anbefalinger</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 mr2 regular" id="indhent-anbefalinger">
                                <div>
                                    <p  type="button" class=" nav-link">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Indhent anbefalinger
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li
                                class="nav-item darkblue gibson h5 mr2 regular"
                                id="laes-og-besvar-anbefalinger">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Læs og besvar
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 mr2 regular" id="auto-anbefalinger">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Sæt anbefalinger på Auto-pilot
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 mr2 regular" id="widgets">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Widgets
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 semi-bold">
                        <div>
                            <p  type="button" class="nav-link m0">
                                <i class="el-icon-files mr2 darkblue"></i>
                                <span class=" inline-block ">Mine kunder
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown active">
                        <div id="dropDine projekter" class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-picture-outline mr2 darkblue"></i>
                            Dine projekter</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 regular" id="opret-projekt-new">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Opret projekt
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 regular" id="status-haandvaerker-new">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Mine projekter
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li
                                class="nav-item darkblue gibson h5 regular"
                                id="customer-projects/approved-projects">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Åbne kundeprojekter
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li
                                class="nav-item darkblue gibson h5 regular"
                                id="customer-projects/project-dashboard">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Vundne kundeprojekter
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown active">
                      <div  class="nav-link nav-dropdown-toggle">
                        <i class="el-icon-money mr2 darkblue"></i> 
                        Markedsplads</div> 
                        <ul class="nav-dropdown-items"><li class="nav-item darkblue gibson h5 semi-bold hide" id="udbud"><div>
                          <p  type="button" class=" nav-link m0"><i class=""></i> 
                          <span class="plpointtwo inline-block ">Udbud </span> <!----></p></div></li></ul></li>
                    <li @click="nextstep()" class="nav-item nav-dropdown active">
                        <div id="dropMester-til-Mester" class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-share mr2 darkblue"></i>
                            Mester-til-Mester</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 regular" id="mester-arbejdskraft">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Arbejdskraft
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 regular" id="mester-opgaver">
                                <div>
                                    <p  type="button" href="#/mester-opgaver"  class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Opgaver
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown active">
                        <div  class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-document mr2 darkblue"></i>
                            Opret tilbud</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 regular" id="tilbud/tilbud-historie">
                                <div>
                                    <p  type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Tilbudshistorie
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 regular" id="tilbud/standardTilbud">
                                <div>
                                    <p type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Standard Tilbud
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 regular" id="tilbud/hurtigt-tilbud">
                                <div>
                                    <p type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Hurtigt Tilbud
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                            <li class="nav-item darkblue gibson h5 regular" id="tilbud/upload-tilbud">
                                <div>
                                    <p type="button" class=" nav-link m0">
                                        <i class=""></i>
                                        <span class=" inline-block ">Upload Tilbud
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 regular hide">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-present mr2 darkblue"></i>
                                <span class=" inline-block ">Inviter en kollega
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 semi-bold nav-dropdown-toggle">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-monitor mr2 darkblue"></i>
                                <span class="inline-block ">Gratis hjemmeside
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 regular">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-present mr2 darkblue"></i>
                                <span class="inline-block ">Medlemsfordele
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item nav-dropdown active">
                        <div class="nav-link nav-dropdown-toggle">
                            <i class="el-icon-shopping-cart-2 mr2 darkblue"></i>
                            Webshop</div>
                        <ul class="nav-dropdown-items">
                            <li class="nav-item darkblue gibson h5 regular" id="webshop/products">
                                <div>
                                    <p type="button" class=" nav-link">
                                        <i class=""></i>
                                        <span class="plpointtwo inline-block ">Alle produkter
                                        </span>
                                        <!---->
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 semi-bold">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-present mr2 darkblue"></i>
                                <span class="inline-block ">Digital pakke
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 semi-bold">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-setting mr2 darkblue"></i>
                                <span class=" inline-block ">Indstillinger
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 regular">
                        <div>
                            <p  type="button" class=" nav-link m0">
                                <i class="el-icon-question mr2 darkblue"></i>
                                <span class=" inline-block ">Ofte stillede spørgsmål
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                    <li @click="nextstep()" class="nav-item darkblue gibson h5 regular pt3">
                        <div>
                            <p type="button" class=" nav-link m0">
                                <i class="el-icon-back mr2 darkblue"></i>
                                <span class=" inline-block ">Log ud
                                </span>
                                <!---->
                            </p>
                        </div>
                    </li>
                </ul>
            </nav>
            <div></div>
        </div>
        <main class="main p2">
          <div class="col-12  p0 ">
            <div class="flex justify-start mt3">
              <p class="h4 semi-bold line-height-2 my2 darkblue">
                Markedsplads
              </p>
            </div>
            <p class="lg-col-10 md-col-11 h5 regular darkblue line-height-golden my3">
              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.
            </p>
            <div class="col-12 px0 flex flex-wrap items-center">
            <button v-if="job"  class="sm-hide outlined-standard-button gibson p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2 mr1" style="width:435px;">
              <span class="mr2">
                <svg fill="currentColor" width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"></path><path d="M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"></path><path d="M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"></path><path d="M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"></path><path d="M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"></path></svg>
              </span>
              <span>
                Se opgaver
              </span>
            </button>
            <button @click="nextstep()" v-if="!job" class="sm-hide outlined-standard-button gibson p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2 mr1" style="width:435px;">
              <span class="mr2">
                <svg fill="currentColor" height="40" width="40" id="Capa_1" enable-background="new 0 0 516.037 516.037" viewBox="0 0 516.037 516.037" xmlns="http://www.w3.org/2000/svg"><g><path d="m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"></path><path d="m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"></path><path d="m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"></path></g></svg>
              </span>
              <span>
                Se ledige arbejdskraft
              </span>
            </button>
            <button @click="nextstep()" v-if="!job" class="darkblue-background p2 px3 h5 not-rounded flex justify-center white items-center line-height-1 my2 mr1" style="width:435px;height:77px;border: 0px solid;">
              <span>
                Antal reservationer: 0 ud af 3
              </span>
            </button>
          </div>
          </div>
          <div class="clearfix mx-auto" v-if="loadingjobs">
          <div class="col-12 ">
            <div class="loader"></div>
          </div>
        </div>
        <div  v-else>
          <div v-if="!showMobile">
            <div class="flex flex-wrap items-center justify-start">
          <div @click="nextstep()" class="muted-border border shadow px0 pb3 mr2 mb2" v-for="item in SearchItem" :key="item.id" style="overflow:hidden;cursor:pointer!important;width:300px;" >
            <div class="col-12 px0 relative" style="height:inherit;">
              <img :data-key="item.appid + 'd'" alt=""  :src="item.image" loading="lazy"  class="fit block" style="height:180px;object-fit: none;width:100%;">
              <div class="absolute top-0 right-0 left-0">
                <span class="mintgreen-background p1 line-height-1 block px2 flex items-center" style="height:51px;">
                  <span class="h6 m0 p0 white semi-bold block" v-if="item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' ">
                    {{ item.mailingzip }}
                  </span>
                  <span class="h6 m0 p0 white semi-bold block">
                    {{ item.mailingcity }}
                  </span>
                </span>
                <template v-if="item.gratis1 === '1'">
                  <span class="white-background p1 line-height-1 block px2">
                    <span class="h6 m0 p0 mintgreen semi-bold block">
                      Gratis møde
                    </span>
                  </span>
                </template>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="px2">
              <div class="flex flex-column">
                <p class="h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center" style="height:41px;">
                  <span>{{ item.producttitle }}</span>
                </p>
                <template>
                  <p class="h6 darkblue regular line-height-2 mb1" style="height:60px;" v-if="item.reserved !== 1">
                    {{ item.comment_to_partner | truncate(80, '...') }}
                  </p>
                </template>
                <p class="darkblue gibson semi-bold m0 line-height-1">
                  <span class="relative" style="top:7px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d='M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z'/></svg>
                  </span>
                  <span v-if="item.henttilbud === 1">Ring og aftal møde-dato</span>
                </p>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div v-else>
            <div class="flex flex-wrap items-center justify-center">
            <div class="clearfix muted-border border shadow mb3 px0" v-for="item in SearchItem" :key="item.key"  @click="nextstep()" style="height:140px;overflow:hidden;cursor: pointer!important;">
              <div class="col col-4 px0 relative" style="height:inherit;">
                <img :data-key="item.appid + 'd'" alt=""  :src="item.image"  loading="lazy" class="fit block" style="min-height:100%;object-fit: none;">
                <div class="absolute top-0 right-0 left-0">
                  <span class="mintgreen-background p1 line-height-1 block flex items-center" style="height:41px;">
                    <span class="h6 m0 p0 white semi-bold block" v-if="item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' ">
                      {{ item.mailingzip }}
                    </span>
                    <span class="h6 m0 p0 white semi-bold block">
                      {{ item.mailingcity }}
                    </span>
                  </span>
                </div>
                <div class="absolute bottom-0 right-0 left-0 hide" v-if="item.gratis1 === '1'">
                  <div class="white-background mintgreen gibson line-height-1 h6 mb0 p1 pb2">
                    <span class="block hide">Gratis møde  </span>
                  </div>
                </div>
              </div>
              <div class="col col-8 px2 pr0">
                <div class="flex flex-column">
                  <p class="h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center">
                    <span>{{ item.producttitle }}</span>
                    <span class="red" v-if="item.reserved === 1">Reserved</span>
                  </p>
                  <template>
                    <p class="h5 darkblue regular line-height-2 mb1" v-if="item.reserved !== 1">
                      {{ item.comment_to_partner | truncate(50, '...') }}
                    </p>
                  </template>
                  <p class="h6 darkblue gibson semi-bold m0 line-height-1">
                    <span class="relative mr1" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d='M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z'/></svg>
                    </span>
                    <span  v-if="item.henttilbud !== 1">{{ moment(item.appointment_date).locale('da').format('LL') }}</span>
                    <span v-if="item.henttilbud === 1">Ring og aftal møde-dato</span>
                  </p>
                  <span v-if="item.mester === '1'" class="block flex self-end h6 semi-bold  mintgreen pt1 line-height-1">Mester-til-Mester</span>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        </main>
      </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <b-modal  centered  hide-footer hide-header id="confirmcvr" :no-close-on-backdrop="true" ref="confirmcvr">
        <div class="col-12 flex justify-end items-center white-background p0">
          <button type="button" @click="backstep() " class="white-button no-border not-rounded gibson pt1 ">
            <span>
            <i class="el-icon-close h5 "></i>
            </span>
          </button>
        </div>
        <div class="clearfix col-12 flex justify-center item-center" v-if="loading">
            <div class="col-12 flex flex-column justify-center item-center">
              <div class="loader"></div>
              <p class="mediumgrey bold center">Få tilgængelig dato og tid</p>
            </div>
            </div>
            <div class="col-12 p0 mmb5" v-else>
                <div class="flex justify-around lg-col-4 md-col-4 sm-col-12 mx-auto items-center mt1">
                  <span class="flex flex-column items-center"><svg xmlns="http://www.w3.org/2000/svg" width="49.036" height="56.623" viewBox="0 0 49.036 56.623">
                        <path id="Indtast_Info" data-name="Indtast Info" d="M30.637,53.466a10.929,10.929,0,0,1-1.054-1.221H6.424A6.431,6.431,0,0,1,0,45.821V6.424A6.431,6.431,0,0,1,6.424,0H26.141a1.5,1.5,0,0,1,.969.372l.007,0,.014.013.052.05L41.957,15.213c.023.023.046.048.068.073a1.505,1.505,0,0,1,.371.969V35.887a10.781,10.781,0,1,1-11.759,17.58Zm-.157-7.621a7.778,7.778,0,1,0,7.779-7.779A7.787,7.787,0,0,0,30.479,45.845ZM3,6.424v39.4a3.428,3.428,0,0,0,3.424,3.424h21.6A10.785,10.785,0,0,1,38.258,35.067a10.964,10.964,0,0,1,1.139.059V17.773H26.123a1.5,1.5,0,0,1-1.5-1.5V3H6.424A3.428,3.428,0,0,0,3,6.424Zm24.623,8.349h9.652L27.623,5.121Zm9.135,34.782V47.345H34.547a1.5,1.5,0,1,1,0-3h2.211V42.133a1.5,1.5,0,1,1,3,0v2.211h2.211a1.5,1.5,0,1,1,0,3H39.757v2.211a1.5,1.5,0,1,1-3,0ZM11.5,39.882a1.5,1.5,0,1,1,0-3h15a1.5,1.5,0,1,1,0,3Zm0-10a1.5,1.5,0,1,1,0-3h20a1.5,1.5,0,1,1,0,3Zm-.151-9.646a1.5,1.5,0,1,1,0-3h4.925a1.5,1.5,0,0,1,0,3Z" fill="#19a3c0"/>
                      </svg>
                      <p>Indtast info</p>
                  </span>
                  <span class="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9.382" height="16.409" viewBox="0 0 9.382 16.409">
                      <path id="Icon_ionic-ios-arrow-forward" data-name="Icon ionic-ios-arrow-forward" d="M17.8,14.4l-6.209-6.2a1.168,1.168,0,0,1,0-1.656,1.182,1.182,0,0,1,1.661,0l7.035,7.03a1.17,1.17,0,0,1,.034,1.617l-7.064,7.079A1.173,1.173,0,1,1,11.6,20.607Z" transform="translate(-11.246 -6.196)" fill="#23a3c0"/>
                    </svg>
                  </span>
                  <span class="flex flex-column items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="56.623" height="56.623" viewBox="0 0 56.623 56.623">
                      <path id="Activer" d="M0,28.312A28.311,28.311,0,1,1,28.312,56.623,28.312,28.312,0,0,1,0,28.312ZM18.452,51.653a25.3,25.3,0,0,0,26.31-4.078v-4.45a7.6,7.6,0,0,0-7.59-7.59H19.014a7.59,7.59,0,0,0-7.59,7.59v4.067A25.2,25.2,0,0,0,18.452,51.653Zm18.72-19.1a10.583,10.583,0,0,1,10.57,10.57v1.439A25.333,25.333,0,1,0,4.97,18.452,25.31,25.31,0,0,0,8.443,44.03v-.9a10.571,10.571,0,0,1,10.57-10.57ZM17.523,15.887A10.57,10.57,0,1,1,28.093,26.457,10.582,10.582,0,0,1,17.523,15.887Zm2.98,0a7.59,7.59,0,1,0,7.59-7.59A7.6,7.6,0,0,0,20.5,15.887Z" fill="#19a3c0"/>
                    </svg>
                    <p>Aktiver</p>
                  </span>
                </div>
                <div class="max-width-4 mx-auto flex flex-column p1 mx3 mt1 mb2 darkblue">
                  <div class="center mb1 mt2" ><p class="h4  semi-bold">Prøv 30 dage gratis</p></div>
                  <div class="lg-col-10 md-col-10 sm-col-12 mx-auto center mt1 mb2"><p class="h6 line-height-golden">& Få 3 gratis opgaver ved oprettelse</p></div>
                    <el-form id="cvrfrom" :model="form2" class="demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto" :rules="rulesform2" ref="step4formcontact" label-position="top">
                        <div class="flex flex-column">
                          <div class="m0 p0  mp0 lg-col-12 md-col-12 sm-col-12">
                            <el-form-item label="CVR" prop="cvr" class="border-none el-form-opgavetype  p0 mr-auto" >
                                <el-input v-model.number="form2.cvr" maxlength="8" class="border wizard-border white-background" @keyup="validatecvrinput()" placeholder="12345678"></el-input>
                            </el-form-item>
                          </div>
                          <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                            <el-form-item label="Email" prop="email" class="border-none el-form-opgavetype p0 mr-auto">
                                <el-input v-model="form2.email"  class="border wizard-border white-background" placeholder="E-mail"></el-input>
                            </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-12 md-col-12 sm-col-12">
                            <el-form-item label="Telefonnummer" id="Telefonnummer" prop="telefonnummer" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-input v-model.number="form2.telefonnummer" maxlength="8" class="border wizard-border white-background" oninput="onlyNumber('phone')" id="phone" ref="phone" placeholder="Mobilnr.(8 cifre)"></el-input>
                            </el-form-item>
                          </div>
                          <el-alert v-if="showcvr" :title="cvrerror" type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert>
                          <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                            <el-form-item label="Fulde Navn" prop="fullname" class="border-none el-form-opgavetype  p0 mr-auto">
                                <el-input v-model="form2.fullname" class="border wizard-border white-background" placeholder="Hans Hansen"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="center p0 col-12">
                          <button type="button" @click="updateinfo(), tracking2()" class="mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover  p2 px3 line-height0 mb1">Aktiver <i class="pl1 el-icon-right"></i>
                          </button>
                      </div>
                    </el-form>
                </div>
            </div>
        <div slot="modal-footer" class="col-12 m0 darkblue-background flex flex-column items-center justify-center">
          <div class="flex justify-center items-center ">
            <div class="flex flex-column py2">
            <span class="mr1 center">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white center">Håndværker.dk</p>
            <p class="center white" style="font-size:13px;" >Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail <a target="_blank" href="mailto:https://info.haandvaerker.dk">info@haandvaerker.dk.</a></p>
            </div>
            </div>
        </div>
    </b-modal>
    <b-modal  @show="limitleverantext()" centered  hide-footer hide-header id="payments" :no-close-on-backdrop="true" ref="payments">
        <div class="clearfix col-12 flex justify-center item-center" v-if="loadingnewpayment">
            <div class="col-12 flex flex-column justify-center item-center">
              <div class="loader"></div>
              <p class="mediumgrey bold center">Få tilgængelig dato og tid</p>
            </div>
            </div>
        <div v-else>
          <div class="p2 flex justify-center mmt4">
            <div id="subitemitem1" class="subitems mt4 relative flex flex-column item-between height-full py4 px1 relative" style="width:390px;box-shadow: 0px 0px 20px #19A3C04D;">
                    <div id="subicons" class=" absolute top-0 left-0 bottom-0 right-0 mb1 primarycolor-background relative ">
                          <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" class="absolute" style="top: 20%;left: 25%;" viewBox="0 0 128.416 110.912">
                            <path id="Freemium" d="M55.035,110.912a1.529,1.529,0,1,1,0-3.057H61.1v-1.529H48.92a1.529,1.529,0,0,1,0-3.058H79.5a1.529,1.529,0,0,1,0,3.058H67.311v1.529h6.834a1.529,1.529,0,0,1,0,3.057Zm28.928-4.586a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm-45.862,0a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm77.106-6.115h-102a1.542,1.542,0,1,1,0-3.058h47.2a18.384,18.384,0,0,1-.816-6.211,3.058,3.058,0,0,1,3.056-2.961h3.041a3.079,3.079,0,0,1,3.057,3,16.872,16.872,0,0,1-.929,6.169h47.395a1.542,1.542,0,1,1,0,3.058Zm-51.54-3.382h0a1.527,1.527,0,0,0,.5.324c.685-.272,1.625-2.633,1.52-6.089v-.025H62.645C62.56,93.719,63.1,96.289,63.668,96.829Zm61.689,1.853a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,125.357,98.683Zm-5.351,1.529a1.529,1.529,0,0,1,0-3.058H122.3a1.529,1.529,0,0,1,0,3.058Zm-113.892,0a1.529,1.529,0,0,1,0-3.058H8.408a1.529,1.529,0,0,1,0,3.058ZM0,98.683a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,0,98.683ZM68.532,84.924H59.879a4.561,4.561,0,0,1-4.554-3.969c-.049-.4-.1-.867-.165-1.381H51.284a3.08,3.08,0,0,1-3.122-2.8L45.134,63.087a1.529,1.529,0,0,1,2.23-1.67l6.291,3.461c-.713-8.326-1.23-17.6-.68-23.241.257-2.627,1.812-9.432,2.036-10.405a9.4,9.4,0,0,1,18.395-.014c.224.964,1.775,7.695,2.031,10.294.558,5.665.037,15-.68,23.368l6.294-3.463a1.528,1.528,0,0,1,2.23,1.67L80.253,76.77a3.08,3.08,0,0,1-3.122,2.8H73.252c-.061.514-.117.978-.166,1.381a4.56,4.56,0,0,1-4.522,3.97ZM56.017,41.935c-.987,10.109,1.656,33,2.343,38.65a1.5,1.5,0,0,0,1.519,1.281h8.653a1.5,1.5,0,0,0,1.518-1.281c.689-5.665,3.341-28.635,2.343-38.772-.154-1.569-.882-5.037-1.41-7.432a17.191,17.191,0,0,1-6.776,1.241,17.2,17.2,0,0,1-6.769-1.238C56.91,36.807,56.174,40.341,56.017,41.935ZM74.426,68.553c-.281,2.965-.57,5.7-.823,7.963h3.528A.185.185,0,0,0,77.2,76.5a1.5,1.5,0,0,1,.035-.259l2.327-10.518ZM51.177,76.242a1.575,1.575,0,0,1,.034.26.188.188,0,0,0,.073.013h3.524c-.253-2.267-.542-5-.823-7.964L48.85,65.725ZM58.145,31.3c.69.5,2.759,1.264,6.063,1.264s5.378-.77,6.066-1.266a6.313,6.313,0,0,0-6.064-4.467h-.027A6.314,6.314,0,0,0,58.145,31.3Zm4.493,45.216V63.521a1.528,1.528,0,0,1,1.528-1.529h0a1.529,1.529,0,0,1,1.529,1.529l0,12.994a1.529,1.529,0,1,1-3.058,0ZM58.092,51.673V46.322a6.115,6.115,0,0,1,12.23,0v5.351a6.115,6.115,0,1,1-12.23,0Zm3.058-5.351v5.351a3.058,3.058,0,1,0,6.115,0V46.322a3.058,3.058,0,0,0-6.115,0Zm58.325,4.2A1.529,1.529,0,1,1,121,52.056,1.529,1.529,0,0,1,119.476,50.527Zm.764,0a.765.765,0,1,0,.764-.765A.765.765,0,0,0,120.24,50.527ZM6.516,50.86,7.652,49.4v-.023l-1.77.226v-.813l1.759.227v-.023L6.516,47.536l.73-.419.742,1.663h.024l.73-1.674.718.407L8.323,49.007v.023l1.805-.239V49.6l-1.805-.215v.024l1.148,1.435-.754.431L8,49.6H7.975L7.2,51.291Zm82.722-6.327a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,89.238,44.533Zm.764,0a.764.764,0,1,0,.764-.765A.764.764,0,0,0,90,44.533ZM34.4,34.381a2.293,2.293,0,1,1,2.293,2.294A2.293,2.293,0,0,1,34.4,34.381Zm1.147,0a1.146,1.146,0,1,0,1.146-1.146A1.146,1.146,0,0,0,35.544,34.381Zm79.625-.422,1.114-1.431V32.5l-1.736.222v-.8l1.725.224v-.024l-1.1-1.432.716-.41.727,1.63h.023l.715-1.642.7.4L116.94,32.14v.023l1.771-.235v.8l-1.771-.211v.023l1.125,1.408-.739.422-.7-1.643H116.6l-.763,1.655ZM85.61,19.187a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,85.61,19.187Zm.765,0a.764.764,0,1,0,.764-.764A.764.764,0,0,0,86.375,19.187Zm-76.2-1.529A1.529,1.529,0,1,1,11.7,19.187,1.529,1.529,0,0,1,10.17,17.659Zm.764,0a.764.764,0,1,0,.764-.764A.766.766,0,0,0,10.934,17.659ZM111.49,9.253l.962-1.234V8l-1.5.192V7.5l1.487.193V7.675L111.49,6.44l.618-.354.627,1.406h.021l.617-1.416.607.344-.961,1.264v.021l1.527-.2v.688l-1.527-.182v.02l.971,1.215-.638.365-.607-1.417h-.02l-.658,1.427ZM59.07,2.162l.654-.84V1.308l-1.02.131V.971l1.013.131V1.088L59.07.248l.42-.241.427.957h.014L60.351,0l.413.234-.654.861v.014L61.15.971v.468l-1.039-.124v.014l.661.826-.434.248-.413-.964h-.013l-.449.971Z" fill="#fff"/>
                          </svg>
                    </div>
                  <div>
                    <p class="col-12 center bold h6 my2">PRØVEPAKKE</p>
                    <p class="col-12 center bold h2 my2"><span class="primarycolor">GRATIS*</span></p>
                  </div>
                  <div class="col-10 mx-auto">
                    <ul class="list-sub-text list-image-check-mintgreen pb1 pr2 mb3">
                          <li class=" light line-height-4 mt0 pb1 ml1">Byd på 3 opgaver</li>
                          <li class=" light line-height-4 mt0 pb1 mb2 ml1">Gratis adgang i 30 dage</li>
                          <div class="center col-12">
                            <!-- <input type="radio" class="mb2" style="width:30px;height:30px;" v-model="gratisbutton" id="gratisbutton" value="1" /> -->
                            <button type="button" @click="goto()" class="action-button p2 px3 round">Vælg</button>
                            <!-- <p class="h5 flex items-center m0"></p> -->
                          </div>
                    </ul>
                  </div>
                </div>
          </div>
          <div>
            <div class="lg-col-12 md-col-12 sm-col-12 mx-auto mx3">
              <div class="col-12 center pb2 flex flex-column darkblue lightgrey-background">
                <p class="h4 semi-bold my1 col-12 flex justify-start py2 px0">Kurv</p>
                <p class="h6 semi-bold my1 col-12 flex justify-start p0">Plan valgt: GRATIS</p>
                <p class=" h3 semi-bold darkblue center my2 col-12 flex justify-start p0">At betale nu: <span class="primarycolor pl2"> 0.- kr</span></p>
                <div class="flex flex-column items-start" style="max-width:920px;">
                  <p class="semi-bold mt1 mb0" style="font-size:12px">Pris per måned:*</p>
                  <p id="leverantext" class="pb1 h6 line-height-golden flex justify-start italic p0" style="font-size:12px">{{leverantext}}</p>
                  <div id="showmore" @click="limitleverantext(1)" class="primarycolor"><span>Læs mere</span></div>
                  <div id="showless" @click="limitleverantext(2)" class="primarycolor"><span>Vis mindre</span></div>
                </div>
                
              </div>
              <div class="col-12 pb2 flex flex-column darkblue lightgrey-background mt2">
                  <p class="semi-bold h4 dawkblue col-12 flex justify-start mt2 px0">Vælg betalingsform</p>
                  <p class="h6 initial mb2">Dette er for at bekræfte din konto. Du bliver ikke opkrævet i din 30 dages prøveperiode.</p>
                  <template>
                  <div>
                    <el-select v-model="selectedpayment" @change="checkboxselect()" placeholder="Vælg"
                      class=" col-12 px0 white-background border-none darkblue semi-bold not-rounded">
                      <el-option v-for="items in paymentoption" :key="items.value" :label="items.text" :value="items.value">
                      </el-option>
                    </el-select>
                  </div>
                  <!-- <div class=" flex col-12 m0 p0 flex-column">
                      <div  @click="checkboxselect('leve')" class=" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center p0">
                        <input type="radio" id="leverandcheckbox" class="" value="1" v-model="leverancheckbox" />
                        <span class="h6 mb0 semi-bold mx2 flex items-center">Leverandørservice (0 kr.)</span>
                      </div>
                      <div  @click="checkboxselect('reep')" class=" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0">
                        <input type="radio"  id="reepaycheckbox" class="" value="1" v-model="reepaycheckbox" />
                        <span class="mx2 h6 semi-bold flex items-center mb0">Kreditkort (0 kr.)</span>
                      </div>
                      <div  @click="checkboxselect('mobpay')" class=" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0">
                        <input type="radio"  id="mobilepaycheckbox" class="" value="1" v-model="mobilepaycheckbox" />
                        <span class="mx2 h6 semi-bold flex items-center mb0">MobilePay (0 kr.)</span>
                      </div>
                  </div> -->
                  <div id="leveran" class="col-lg-12 col-md-12 col-sm-12 p0 mx-auto mt2" v-if="selectedpayment === 'leve'">
                      <div class="d-flex flex-row justify-content-start">
                        <div class="col-12 p0">
                          <b-alert show variant="success" class="my2" v-if="levandorupdate !== ''">
                            <h5 class="alert-heading">Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.
                            </h5>
                            <p>
                            </p>
                          </b-alert>
                              <div class=" col-12 flex flex-wrap mt2 p0">
                                <el-form :model="form" class="tui-f lg-col-12 sm-col-12 sm-col-12 mx-auto" :rules="rulesform" ref="step4formcontact2" label-position="top">
                                  <el-form-item label="Reg. nr." prop="regnr" class="border-none el-form-opgavetype flex mobile-flex-column">
                                      <el-input v-model="form.regnr" maxlength="4" class="border wizard-border white-background col-12 p0" placeholder="4 cifre"></el-input>
                                  </el-form-item>
                                  <el-form-item label="Konto nr." prop="bankkonto" class="border-none el-form-opgavetype flex mobile-flex-column">
                                      <el-input v-model="form.bankkonto" minimum="6" maxlength="10" class="border wizard-border white-background col-12 p0" placeholder="6-10 cifre"></el-input>
                                  </el-form-item>
                                  <el-form-item id="accepterms" class="border-none center el-form-item__plain el-form-item__checkbox">
                                      <el-checkbox label="" @change="changecolor()" id="consentleverancheckbox" class="el-checkbox flex justify-start md-col-10 lg-col-10 sm-col-12 pl1 mp0 ml-auto" v-model="consentleveran">
                                          <span class="second-secondary ">Jeg acceptere betingelser for <span style="color:#3498db;" class="p0" @click="showpopuplinklever()"> LeverandørService</span> og <span style="color:#3498db;" class="p0" @click="showpopupcontract()">abonnement.</span></span>
                                      </el-checkbox>
                                      <el-alert v-if="showerrorleveranerror" title="Indtast venligst nummer" type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert>
                                  </el-form-item>                  
                              </el-form>
                                
                              </div>
                              <div class="col-12 p0 m0">
                                <button type="button" id="leverrsub" @click="service_levendor" class="action-button not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center" style="max-width: 773px;">
                                  <span class="semi-bold h5 m0">Start<i class="el-icon-right"></i></span>
                                </button>
                              </div>
                              <div id="moreid" class="py-2"></div>
                          </div>
                      </div>
                  </div>
                  
                  <div id="reepay" accordion="my-accordion" role="tabpanel" class="col-lg-12 col-md-12 p0 col-sm-12 mx-auto" v-if="selectedpayment === 'reep'">
                  <div id="rp_container" class="col-lg-8 col-md-8 col-sm-12 mx-auto p0 " style="height:500px;"></div>
                  <div class="col-12 p0 my1">
                    <b-form-group label-for="consentInput" class="flex flex-row justify-center">
                      <b-form-checkbox id="consentInput" @change="changecolor()" v-model="consentreepay" class="el-checkbox" value="accepted" required unchecked-value="not_accepted">
                        <span class="second-secondary2">Jeg acceptere betingelser for <span class="p0" style="color:#3498db;"  @click="showpopuplink()" >Kreditkort</span> og <span class="p0" style="color:#3498db;" @click="showpopupcontract()">abonnement</span></span>
                      </b-form-checkbox>
                    </b-form-group>
                    <el-alert v-if="showerrorreepay" title="Accepter venligst vilkår og betingelser" type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert>
                  </div>
                  </div>
                  <div id="mobilepay" class="col-12 flex justify-center" v-if="selectedpayment === 'mobpay'">
                    <div v-if="disablemobilepaybutton">
                      <i class="el-icon-loading"></i>
                    </div>
                    <a type="button" :href="mobilepaylink" class="action-button no-underline not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center" style="max-width: 700px;" v-else>
                        <span class="white semi-bold h5 m0">Start</span>
                    </a>
                  </div>
                  <div id="reepay" accordion="my-accordion" role="tabpanel" class="col-lg-12 col-md-12 p0 col-sm-12 mx-auto" v-if="selectedpayment === 'googlepay'">
                  <div id="rp_container" class="col-lg-8 col-md-8 col-sm-12 mx-auto p0 " style="height:500px;"></div>
                  <div class="col-12 p0 my1">
                    <b-form-group label-for="consentInput" class="flex flex-row justify-center">
                      <b-form-checkbox id="consentInput" @change="changecolor()" v-model="consentreepay" class="el-checkbox" value="accepted" required unchecked-value="not_accepted">
                        <span class="second-secondary2">Jeg acceptere betingelser for <span class="p0" style="color:#3498db;"  @click="showpopuplink()" >Kreditkort</span> og <span class="p0" style="color:#3498db;" @click="showpopupcontract()">abonnement</span></span>
                      </b-form-checkbox>
                    </b-form-group>
                    <el-alert v-if="showerrorreepay" title="Accepter venligst vilkår og betingelser" type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert>
                  </div>
                  </div>
                  <div id="reepay" accordion="my-accordion" role="tabpanel" class="col-lg-12 col-md-12 p0 col-sm-12 mx-auto" v-if="selectedpayment === 'applepay'">
                  <div id="rp_container" class="col-lg-8 col-md-8 col-sm-12 mx-auto p0 " style="height:500px;"></div>
                  <div class="col-12 p0 my1">
                    <b-form-group label-for="consentInput" class="flex flex-row justify-center">
                      <b-form-checkbox id="consentInput" @change="changecolor()" v-model="consentreepay" class="el-checkbox" value="accepted" required unchecked-value="not_accepted">
                        <span class="second-secondary2">Jeg acceptere betingelser for <span class="p0" style="color:#3498db;"  @click="showpopuplink()" >Kreditkort</span> og <span class="p0" style="color:#3498db;" @click="showpopupcontract()">abonnement</span></span>
                      </b-form-checkbox>
                    </b-form-group>
                    <el-alert v-if="showerrorreepay" title="Accepter venligst vilkår og betingelser" type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert>
                  </div>
                  </div>
                  </template>
              </div>
              <div class="hide" id="lastitem"></div>
            </div>
          </div>
        </div>
        <div slot="modal-footer" class="col-12 m0 darkblue-background flex flex-column items-center justify-center">
          <div class="flex justify-center items-center ">
            <div class="flex flex-column py2">
            <span class="mr1 center">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white center">Håndværker.dk</p>
            <p class="center white" style="font-size:13px;" >Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail <a target="_blank" type="button" href="mailto:https://info.haandvaerker.dk">info@haandvaerker.dk.</a></p>
            </div>
            </div>
        </div>
    </b-modal>
    <b-modal  centered  hide-header id="incorrecturl" :no-close-on-backdrop="true" ref="incorrecturl">
        <div class="py1" ></div>
        <div class="clearfix white-background ">
          <div class="flex flex-column col-12 p0">
            <p class="my2 darkblue mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </p>
            <p class="bold h3 darkblue pt1 mx-auto" >Tak for besøget</p>
              <p class="h6 darkblue py1 mt2 mx-auto" >Der er noget galt med det link, du modtager</p>
              <span class="h6 semi-bold my3 center">e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager</span>
          </div>
        </div>
        <div class="col-12 flex justify-center items-center py1 mx">
          <a href="https://www.haandvaerker.dk" disabled="true" class="regular p2 action-button center white"> Bekræft</a>
        </div>
        <div slot="modal-footer" class="col-12 m0 darkblue-background flex flex-column items-center justify-center">
          <p class="white" style="font-size:14px;">Alt det bedste</p>
          <div class="flex justify-center items-center ">
            <span class="mr1">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white">Håndværker.dk</p>
            </div>
        </div>
    </b-modal>
    <b-modal  centered hide-header id="sendingsuccess" :no-close-on-backdrop="true" ref="sendingsuccess">
          <div class="py1" ></div>
          <div class="clearfix white-background  m2">
            <div class="flex flex-column gibson col-12">
              <p class="my2 darkblue mx-auto " >
                <svg xmlns="http://www.w3.org/2000/svg" width="92.257" height="92.263" viewBox="0 0 92.257 92.263">
                  <path id="Path_26" data-name="Path 26" d="M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z" transform="translate(2948 1462.006)" fill="#8fde5e"/>
                </svg>  
              </p>
              <p class="semi-bold h4 darkblue pt1 mx-auto center" >TILLYKKE! Så er din prøveperiode aktiveret! 
                Nu mangler du blot at opdatere din virksomhedsprofil, så vi kan låse op for opgaverne på markedspladsen
                </p>
                <p class="h5 darkblue py1 mx-auto center" >Din plan er nu aktiv, og du kan begynde at byde på ledige opgaver, så snart du har opdateret din virksomhedsprofil. Vi har også sendt dig en e-mail med bekræftelse på din konto-aktivering.</p>
              <a type="button" :href="shorturl" class="center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center">
                <span class="mx2 my1">Opdateret virksomhedsprofil</span>
              </a>
              <p class="h6 darkblue py1 mx-auto center line-height-4" >Bemærk, at såfremt du har valgt en “gratis” plan til 0 kr., har du 30 dage til at opsige denne, hvis du ikke ønsker at din plan automatisk skal opgraderes til en “Vækst” plan til 3.299,- pr. måned ex. moms, med en binding på løbende måned + 3 måneder, fra den dato “Vækst” planen træder i kraft.<br><br>
                I prøveperiode opsiger du ved at sende en e-mail til <a target="_blank" href="mailto:info@haandvaerker.dk">info@haandvaerker.dk.</a> Planen bliver trukket automatisk via din valgte betalingsmetode. Du kan læse mere om vores handelsbetingelser <a href="https://www.haandvaerker.dk/om/betingelser?ref=bm" target="_blank" >her.</a> 
              </p>
            </div>
            <div class="flex justify-center flex-column items-center">
              <p class="darkblue h5 semi-bold my2">Rigtig god budgivning!</p>
              <p class="darkblue h5 semi-bold">De bedste hilsner,</p>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 m0 darkblue-background flex flex-column items-center justify-center">
          <div class="flex justify-center items-center ">
            <div class="flex flex-column py2">
            <span class="mr1 center">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white center">Håndværker.dk</p>
            <p class="center white" style="font-size:13px;" >Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail <a target="_blank" href="mailto:https://info.haandvaerker.dk">info@haandvaerker.dk.</a></p>
            </div>
            </div>
          </div>
    </b-modal>
    <b-modal  centered  hide-header hide-footer id="popupcontract" ref="popupcontract">
          <div class="col-12 flex justify-end items-center white-background ">
            <button type="button" @click="closepopupcontract() " class="white-button no-border not-rounded gibson ">
              <span>
              <i class="el-icon-close"></i>
              </span>
            </button>
          </div>
          <div class="py1 col-12 relative" style="width:100%;height:95%;" >
            <iframe :src="'https://www.kundematch.dk/s/otheraftale_new.php?bitrixid=' + this.levid + '&mode=ssl'" frameborder="0" zoom="0.9" style="overflow:hidden;padding:10px;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px;zoom:.5;" height="100%" width="100%">

            </iframe>
          </div>
    </b-modal>
    <b-modal  centered hide-header  hide-footer id="popuplink"  ref="popuplink">
          <div class="col-12 flex justify-end items-center white-background ">
            <button type="button" @click="closepopuplink() " class="white-button no-border not-rounded gibson ">
              <span>
              <i class="el-icon-close"></i>
              </span>
            </button>
          </div>
          <div class="py1 col-12 relative" style="width:100%;height:95%;" >
            <iframe src="https://reepay.com/terms-of-service/" frameborder="0" style="overflow:hidden;padding:10px;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%">

            </iframe>
          </div>
    </b-modal>
    <b-modal  centered hide-header hide-footer id="popuplinklever" ref="popuplinklever">
          <div class="col-12 flex justify-end items-center white-background  ">
            <button type="button" @click="closepopuplinklever() " class="white-button no-border not-rounded gibson ">
              <span>
              <i class="el-icon-close"></i>
              </span>
            </button>
          </div>
          <div class="py1 col-12 p0 relative" style="width:100%;height:95%;overflow:auto;" >
            <vue-pdf-app pdf="/static/pdf/Generelle_regler_for-kreditorer_i_LeverandørService_v_1.0_14.09.2019.pdf"></vue-pdf-app>
          </div>
    </b-modal>
    <b-modal  centered  hide-header id="expiredurl" :no-close-on-backdrop="true" ref="expiredurl">
        <div class="py1" ></div>
        <div class="clearfix white-background ">
          <div class="flex flex-column col-12 p0">
            <p class="my2 darkblue mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </p>
            <p class="bold h3 darkblue pt1 mx-auto" >Tak for besøget</p>
              <p class="h6 darkblue py1 mt2 mx-auto" >Dit link er allerede brugt.</p>
              <span class="h6 semi-bold my3 center">Du har en e-mail med login og password, så du kan logge ind nu.</span>
          </div>
        </div>
        <div class="col-12 flex justify-center items-center py1 mx">
          <a href="https://www.haandvaerker.dk" class="regular p2 action-button center white"> Bekræft</a>
        </div>
        <div slot="modal-footer" class="col-12 m0 p2 darkblue-background flex flex-column items-center justify-center">
          <p class="white pl2" style="font-size:14px;">Alt det bedste</p>
          <div id="modalmainfooter" class="flex justify-center items-center">
            <span class="mr1">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white">Håndværker.dk</p>
            </div>
        </div>
    </b-modal>
	</div>
</template>
<script>
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'
import Simplert from 'vue2-simplert'
import axios from 'axios'
import { Datetime } from 'vue-datetime'
export default {
  name: 'signup',
  components: {
    Simplert,
    datetime: Datetime,
    VuePdfApp,
    axios
  },
  watch: {
  },
  data () {
    return {
      loadingnewpayment: false,
      reepaycheckbox: '0',
      leverancheckbox: '1',
      mobilepaycheckbox: '0',
      pid: '',
      fullurl: '',
      disablemobilepaybutton: false,
      showcvr: false,
      cvrerror: '',
      originalid: '',
      levid: '',
      blockid: '',
      step: 1,
      jobstotal: '',
      jobstotalstatic: 3,
      SearchItem: [],
      loading: false,
      loadingjobs: false,
      showsessionnewcreditpro: '',
      disableupdateinfo: false,
      form2: {
        fullname: '',
        email: '',
        telefonnummer: '',
        companyname: '',
        address: '',
        postnum: '',
        city: '',
        cvr: '',
        mobilenummber: ''
      },
      form: {
        regnr: '',
        bankkonto: ''
      },
      rulesform2: {
        fullname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit navn',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        companyname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt 8 digit mobilnr.',
          trigger: 'blur'
        }],
        postnum: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste et gyldigt postnum.',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt by.',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt Addresse.',
          trigger: 'blur'
        }],
        cvr: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Indtast venligst et gyldigt cvr og 8 cifre.',
          trigger: 'blur'
        }]
      },
      rulesform: {
        bankkonto: [{
          min: 6,
          max: 10,
          message: 'Indtast venligst et gyldigt 6 til 10-cifret nummer.',
          trigger: 'blur'
        },
        {
          required: true,
          type: 'string',
          message: 'Indtast venligst nummer.',
          trigger: 'blur'
        }
        ],
        regnr: [{
          required: true,
          type: 'string',
          max: 4,
          message: 'Indtast venligst et gyldigt 4-cifret nummer.',
          trigger: 'blur'
        }]
      },
      salesPerson: '',
      hasleveran: '',
      levandorupdate: '',
      regnr: '',
      bankkonto: '',
      options: [],
      bank: '',
      cvr: '',
      gratisbutton: 1,
      consentleveran: true,
      consentreepay: 'accepted',
      leverantext: '',
      isvalidcvr: '',
      showerrorleveran: false,
      showerrorleveranerror: false,
      showerrorreepay: false,
      statusstep: '',
      job: false,
      shorturl: '',
      showMobile: '',
      isused: '',
      mobilepaylink: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      datamethod: '',
      selectedpayment: 'leve',
      paymentoption: [
        { value: 'leve', text: 'Leverandørservice (0 kr.)' },
        { value: 'reep', text: 'Kreditkort (0 kr.)' },
        { value: 'mobpay', text: 'MobilePay (0 kr.)' }
      ],
      originalsubpage: '',
      originalmainpage: ''
    }
  },
  created () {
    localStorage.removeItem('yourfulllink')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.fullurl = window.location.href
    var pathArray = window.location.href.split('/')
    localStorage.setItem('yourid', pathArray[pathArray.length - 1])
    localStorage.setItem('yourfulllink', this.fullurl)
    this.originalid = localStorage.getItem('yourid')
    this.originalsubpage = pathArray[pathArray.length - 2]
    this.originalmainpage = pathArray[pathArray.length - 3]
    this.pid = pathArray[pathArray.length - 1]
    if (this.pid !== null) {
      this.decode(this.pid)
    }
    setTimeout(() => {
      document.getElementById('partnerloginapp').style.border = 0
    }, 100)
    this.getdevice()
  },
  mounted: {
  },
  methods: {
    checkboxselect () {
      if (this.selectedpayment === 'reep') {
        setTimeout(() => {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            this.showpopupreepay()
          }
          var colorchange2 = document.querySelector('.second-secondary2')
          colorchange2.style.color = '#409EFF!important'
        }, 100)
      } else if (this.selectedpayment === 'mobpay') {
        this.disablemobilepaybutton = true
        this.registerMobilepay()
      } else if (this.selectedpayment === 'googlepay') {
        setTimeout(() => {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            this.showpopupreepay()
          }
          var colorchange2 = document.querySelector('.second-secondary2')
          colorchange2.style.color = '#409EFF!important'
        }, 100)
      } else if (this.selectedpayment === 'applepay') {
        setTimeout(() => {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            this.showpopupreepay()
          }
          var colorchange2 = document.querySelector('.second-secondary2')
          colorchange2.style.color = '#409EFF!important'
        }, 100)
      }
    },
    getdevice () {
      const ua = navigator.userAgent
      if (/android/i.test(ua)) {
        this.paymentoption.push({ value: 'googlepay', text: 'Google Pay (0 kr.)' })
      } else if (/iPad|iPhone|iPod/.test(ua) || navigator.maxTouchPoints > 1) {
        this.paymentoption.push({ value: 'applepay', text: 'Apple Pay (0 kr.)' })
      }
    },
    checkboxselectold (text) {
      if (text === 'leve') {
        document.getElementById('leverandcheckbox').checked = true
        document.getElementById('reepaycheckbox').checked = false
        document.getElementById('mobilepaycheckbox').checked = false
        document.getElementById('leveran').classList.remove('hide')
        document.getElementById('reepay').classList.add('hide')
        document.getElementById('mobilepay').classList.add('hide')
        this.leverancheckbox = '1'
        this.reepaycheckbox = '0'
        this.mobilepaycheckbox = '0'
        // setTimeout(() => {
        //   document.querySelector('iframe[allow="payment"]').classList.add('hide')
        // }, 100)
      } else if (text === 'mobpay') {
        this.disablemobilepaybutton = true
        this.registerMobilepay()
        document.getElementById('leverandcheckbox').checked = false
        document.getElementById('reepaycheckbox').checked = false
        document.getElementById('mobilepaycheckbox').checked = true
        document.getElementById('leveran').classList.add('hide')
        document.getElementById('reepay').classList.add('hide')
        document.getElementById('mobilepay').classList.remove('hide')
        this.leverancheckbox = '0'
        this.reepaycheckbox = '0'
        this.mobilepaycheckbox = '1'
      } else {
        document.getElementById('leverandcheckbox').checked = false
        document.getElementById('reepaycheckbox').checked = true
        document.getElementById('mobilepaycheckbox').checked = false
        document.getElementById('mobilepay').classList.add('hide')
        document.getElementById('leveran').classList.add('hide')
        document.getElementById('reepay').classList.remove('hide')
        setTimeout(() => {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            this.showpopupreepay()
          }
        }, 100)
        this.reepaycheckbox = '1'
        this.leverancheckbox = '0'
        this.mobilepaycheckbox = '0'
        var colorchange2 = document.querySelector('.second-secondary2')
        colorchange2.style.color = '#409EFF!important'
      }
    },
    changecolor () {
      var colorchange = document.querySelector('.second-secondary')
      colorchange.style.color = '#409EFF!important'
      if (this.consentreepay === 'not_accepted') {
        var colorchange2 = document.querySelector('.second-secondary2')
        colorchange2.style.color = '#606266'
      } else {
        var colorchange3 = document.querySelector('.second-secondary2')
        colorchange3.style.color = '#409EFF!important'
      }
    },
    centericon () {
      setTimeout(() => {
        var icon = document.getElementById('subicons')
        var iconholder = document.getElementById('subitemitem1')
        var iconmarginleft = parseInt(parseInt((iconholder.clientWidth / 2)) - parseInt((117 / 2)))
        icon.style.marginLeft = iconmarginleft + 'px'
      }, 50)
    },
    nextstep () {
      if (this.showsessionnewcreditpro === '') {
        this.showsessionnewcredit()
      }
      this.step = this.step + 1
      if (this.step === 2) {
        this.showconfirmcvr()
      } else if (this.step === 3) {
        this.closeconfirmcvr()
        this.showpayment()
      }
    },
    backstep () {
      if (this.step === 2) {
        this.closeconfirmcvr()
        this.statusstep = 'signup_not_active_step1'
        this.updateleadintegration()
        this.addnotifocationbar()
      } else if (this.step === 3) {
        this.closepayment()
        this.showconfirmcvr()
      }
      this.step = this.step - 1
    },
    showpopupsuccess () {
      this.$refs['sendingsuccess'].show()
    },
    closepopupsucces () {
      this.$refs['sendingsuccess'].hide()
    },
    showpopuperror () {
      this.$refs['incorrecturl'].show()
    },
    showpayment () {
      this.$refs['payments'].show()
    },
    showconfirmcvr () {
      this.$refs['confirmcvr'].show()
    },
    showpopupexpired () {
      this.$refs['expiredurl'].show()
    },
    showpopupcontract () {
      this.$refs['popupcontract'].show()
    },
    showpopuplink () {
      this.$refs['popuplink'].show()
    },
    closepayment () {
      this.$refs['payment'].hide()
    },
    closeconfirmcvr () {
      this.$refs['confirmcvr'].hide()
    },
    closepopuplink () {
      this.$refs['popuplink'].hide()
    },
    closepopuplinklever () {
      this.$refs['popuplinklever'].hide()
    },
    showpopuplinklever () {
      this.$refs['popuplinklever'].show()
    },
    closepopupcontract () {
      this.$refs['popupcontract'].hide()
    },
    limitleverantext (no = 2) {
      this.leverantext = 'Prøvepakken er for dig, der gerne vil teste platformen gratis. Med denne plan, kan du få adgang til platformen i 30 dage for 0 kr. uden binding. Samtidig får du 3 bud helt uden forpligtelser. Du kan til enhver tid nemt opsige Prøvepakke-planen dog inden for planens løbetid. Såfremt du ikke opsiger rettidig, vil din plan automatisk opgradere til en “Vækst” plan. Denne plan koster 3.299 kr. / mdr. ekskl. moms med en binding på løbende måned + 3 måneder jf. vores alm forretningsbetingelser. De 30 dages fri opsigelse tager ikke forbehold for weekender og helligdage og tæller opstartsdagen inklusive. Det er kun muligt at oprette, samt at have en Prøvepakke-plan pr. person/virksomhed.'
      setTimeout(() => {
        var moreText = document.getElementById('showmore')
        var lessText = document.getElementById('showless')
        lessText.classList.add('hide')
        moreText.classList.add('hide')
        var newtext = ''
        if (screen.width <= 640) {
          if (no === 2) {
            newtext = this.leverantext.slice(0, 120)
            this.leverantext = newtext
            lessText.classList.add('hide')
            moreText.classList.remove('hide')
          } else {
            newtext = this.leverantext
            this.leverantext = newtext
            lessText.classList.remove('hide')
            moreText.classList.add('hide')
          }
        }
        document.getElementById('consentleverancheckbox').checked = true
        document.getElementById('leverandcheckbox').checked = true
        document.getElementById('leveran').classList.remove('hide')
        this.centericon()
      }, 100)
    },
    limitsubdetails (no = 2) {
      setTimeout(() => {
        var moreText = document.getElementById('seemoredetails')
        var lessText = document.getElementById('seelesedetails')
        var details = document.getElementById('moredetails')
        var detailsheight = document.getElementById('subcontainerweb')
        // document.getElementById('partnerloginapp').
        if (no === 2) {
          lessText.classList.add('hide')
          moreText.classList.remove('hide')
          details.classList.add('hide')
          var detailsheightoldone = 500
          detailsheight.style.height = detailsheightoldone + 'px'
        } else {
          lessText.classList.remove('hide')
          moreText.classList.add('hide')
          details.classList.remove('hide')
          var detailsheightold = detailsheight.clientHeight
          detailsheight.style.height = parseInt(190 + detailsheightold) + 'px'
        }
      }, 100)
    },
    checkleveranpartner () {
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.cvr = res.cvr
            if (res.levandorupdate === '') {
              this.hasleveran = false
              this.levandorupdate = res.levandorupdate
            } else {
              this.hasleveran = true
              if (this.processingperiod(res.levandorupdate)) {
                this.levandorupdate = ''
              } else {
                this.levandorupdate = res.levandorupdate
              }
            }
            this.nextstep()
            this.form.regnr = res.levandorregnr
            this.form.bankkonto = res.levandorbankkonto
            this.options = res.bankOptions
          },
          response => {
            alert('error')
          }
        )
    },
    processingperiod (a = '') {
      const datenow = new Date()
      const processingstart = new Date(a)
      const processingend = new Date(a)
      processingend.setDate(processingstart.getDate() + 4)
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false
      } else {
        return true
      }
    },
    service_levendor () {
      if (this.consentleveran === 'not_accepted' || this.consentleveran === '') {
        this.showerrorleveran = true
        return
      }
      // if (typeof this.bankkonto === 'string' || typeof this.regnr === 'string') {
      //   this.showerrorleveranerror = true
      //   return
      // }
      var error = 0
      this.$refs['step4formcontact2'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) {
        return false
      }
      this.loadingnewpayment = true
      var dataPartner = {
        operation: 'service_levendor',
        salesPerson: this.salesPerson,
        regnr: this.form.regnr,
        bankkonto: this.form.bankkonto,
        levid: this.levid,
        cvr: this.form2.cvr,
        bank: 'imentor'
      }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.modalShowDato = false
              this.paymenthod = 'leveran'
              this.urlactivated = 1
              this.paymenthodupdate = 1
              this.updateprofilepayment()
            } else {
              this.loadingnewpayment = false
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showsessionnewcredit () {
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              var data = res.data
              this.showsessionnewcreditpro = data.id
            } else {
              console.log('Error in showing session')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
    },
    goto (text) {
      // document.getElementById(text).scrollIntoView({behavior: 'smooth'})
      // $('html, body').animate({ scrollTop: $(document).height() }, 1200)
      var div = document.getElementById('payments')
      div.scrollTo(0, div.scrollHeight, {behavior: 'smooth'})
      // div.animate({
      // }, 1000)
    },
    scrollTo (elementId) {
      var element = document.getElementById(elementId)
      element.scrollIntoView({behavior: 'smooth'})
    },
    registerMobilepay () {
      var dataPartner = {operation: 'registerMobilepay',
        salesPerson: this.salesPerson,
        mobile: this.form2.mobilenummber,
        mobilev: 0,
        acceptUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/1?levid=' + this.levid + '&blockid=' + this.blockid,
        rejectUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/0?levid=' + this.levid
      }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.mobilepaylink = res.url
              this.disablemobilepaybutton = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showpopupreepay () {
      if (this.consentreepay !== 'accepted') {
        this.showerrorreepay = true
        return false
      } else {
        var m = this
        this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true })
        this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
          m.datamethod = ''
          m.showsessionnewcreditpro = m.showsessionnewcreditpro
          console.log('done adding card', data)
          setTimeout(() => {
            m.urlactivated = 1
            m.paymenthod = 'reepay'
            m.paymenthodupdate = 1
            m.updateprofilepayment()
          }, 2000)
        })
      }
    },
    validatecvrinput () {
      setTimeout(() => {
        var datacvr = this.form2.cvr
        this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(
                (response) => {
                  var res = response.body
                  if (res.success) {
                    this.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS
                    this.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY
                    this.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE)
                    this.form2.companyname = res.data.supplier.TITLE
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          })
          .catch(err => {
            console.log(err)
          })
      }, 1000)
    },
    validatecvr () {
      var datacvr = this.form2.cvr
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            if (res.data.error) {
              this.showcvr = true
              this.cvrerror = 'CVR ' + res.data.error
              this.statusstep = 'signup_not_active_step1'
              this.updateleadintegration()
              this.loading = false
            } else {
              if (res.data.enddate !== null) {
                var datenow = new Date()
                var cvrdate = new Date(res.data.enddate)
                if (datenow.getTime() > cvrdate.getTime()) {
                  this.showcvr = true
                  this.cvrerror = 'CVR er inaktivt'
                  this.statusstep = 'signup_not_active_step1'
                  this.updateleadintegration()
                  this.loading = false
                  return false
                }
              }
              this.showcvr = false
              this.cvrerror = ''
              var data = {
                UF_CRM_COMPANY_ZIP_CODE: this.form2.postnum,
                UF_CRM_COMPANY_ADDRESS: this.form2.address,
                UF_CRM_COMPANY_CITY: this.form2.city,
                UF_CRM_COMPANY_CVR: this.form2.cvr,
                UF_CRM_COMPANY_SKIP_PAYMENT_REMINDER: 1,
                PHONE: this.form2.telefonnummer,
                EMAIL: this.form2.email,
                TITLE: this.form2.companyname
              }
              this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplier/' + this.levid, data, { emulateJSON: true }).then(
                (response) => {
                  if (response) {
                    this.nextstep()
                    this.loading = false
                    this.addprofiletoreepay()
                    this.statusstep = 'ready_for_payment_step2'
                    this.updateleadintegration()
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      return true
    },
    formatpris (no) {
      let formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      })
      var tempno = formatter.format(no)
      return tempno
    },
    tracking () {
      var data = {
        site: 'Newpartner',
        message: 'Aktiver',
        user_id: this.form2.cvr.toString(),
        action_context: this.$route.fullPath,
        type: 'web ',
        version: '1'
      }
      this.$http.post('https://tracking.haandvaerker.dk/api/log', { body: data }, { emulateJSON: true }).then(
        response => {
        },
        response => {
        }
      )
    },
    tracking2 () {
      var data = {
        site: window.location.href,
        message: 'Click Aktiver',
        user_id: this.form2.cvr,
        action_type: 'Click Aktiver',
        action_context: this.$route.fullPath,
        type: 'web',
        version: '1'
      }
      var headers = {
        'Content-Type': 'application/json'
      }
      axios({
        method: 'POST',
        headers: headers,
        data: data,
        url: 'https://tracking.haandvaerker.dk/api/log'
      }).then(response => {
      })
    },
    addprofiletoreepay () {
      var data = {
        partnerId: this.levid,
        company: this.form2.companyname,
        name: this.form2.fullname,
        address: this.form2.address,
        address2: '',
        city: this.form2.city,
        zipcode: this.form2.postnum
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/addCustomer/', data, { emulateJSON: true }).then(
        (response) => {
          if (response.data.success) {
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addnotifocationbar () {
      document.getElementById('reminderbar').classList.remove('hide')
    },
    updateinfo () {
      var error = 0
      this.$refs['step4formcontact'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) { return }
      this.loading = true
      this.validatecvr()
    },
    updateleadintegration () {
      var data = {
        stage: this.statusstep,
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(
        (response) => {
          if (response.data.success) {
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateleadintegrationfinal () {
      var data = {
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.updateprofilepayment = false
            this.showpopupsuccess()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onlineSignupIntegration () {
      var data = {
        cvr: this.cvrid,
        source: this.originalmainpage,
        type: this.originalsubpage
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupIntegration', data, { emulateJSON: true }).then(
        (response) => {
          if (response.data.success) {
            this.blockid = response.data.data.ID
            this.getsupplieriblockinfo(this.blockid)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateprofilepayment () {
      this.updateprofilepayment = true
      var data = {
        partnerId: this.levid
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmation', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.updateprofilepaymenttrial()
          } else {
            if (res.message === 'Kundematch api error!') {
              this.updateprofilepaymenttrial()
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateprofilepaymenttrial () {
      var data = {
        partnerId: this.levid
      }
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmTrial', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.updateleadintegrationfinal()
          } else {
            if (res.message === 'Kundematch api error!') {
              this.updateleadintegrationfinal()
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // replacespecial (text) {
    //   var htmlStr = text
    //   htmlStr = htmlStr.replace(/&lt;/g, '<')
    //   htmlStr = htmlStr.replace(/&gt;/g, '>')
    //   htmlStr = htmlStr.replace(/&quot;/g, '')
    //   htmlStr = htmlStr.replace(/&amp;/g, '')
    //   htmlStr = htmlStr.replace(/\\/g, '')
    //   htmlStr = htmlStr.replace('#', '')
    //   htmlStr = htmlStr.replace(/\039;/g, '')
    //   htmlStr = htmlStr.replace(/039;/g, '')
    //   htmlStr = htmlStr.replace(/039;/g, '')
    //   htmlStr = htmlStr.replace('###039', '')
    //   return htmlStr
    // },
    gettotaljobs () {
      this.loadingjobs = true
      // var headers = {
      //   'Cache-Control': {'max-age': '604800'}
      // }
      var data = {operation: 'openjob_partner', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.SearchItem = res.openjob
            this.loadingjobs = false
            this.jobstotal = res.openjob.length
            if (this.jobstotal === 0) {
              this.jobstotal = 457
            }
            this.checkleveranpartner()
          },
          response => {
            console.log('error', response)
          }
        )
    },
    gettotaljobsbitrix () {
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getRelatedJob/' + this.levid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.jobstotal = res.data.totaljob
            if (this.jobstotal === 0) {
              this.jobstotal = 457
            }
          }
        },
        response => {
          console.log('error', response)
        }
      )
    },
    getsupplieriblockinfo (id) {
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.levid = res.data.supplier.VALUE_ID
            localStorage.setItem('levid', res.data.supplier.VALUE_ID)
            var newtel = res.data.supplier.MOBILE.substring(res.data.supplier.MOBILE.length - 8)
            this.isused = res.data.spa.SHORT_URL_ACTIVATED
            if (this.isused === 1) {
              this.showpopupexpired()
              this.loading = false
              return false
            }
            this.loadingjobs = true
            this.form2.telefonnummer = parseInt(newtel)
            this.form2.companyname = res.data.supplier.TITLE
            this.form2.mobilenummber = res.data.supplier.UF_CRM_COMPANY_MOBILE_NUMBER
            this.form2.email = res.data.supplier.EMAIL
            this.form2.fullname = res.data.supplier.UF_CRM_COMPANY_CONTACT_PERSON
            this.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY
            this.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE)
            this.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS
            this.form2.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR)
            this.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR)
            this.shorturl = res.data.token.shorturl
            this.salesPerson = res.data.token.token
            this.gettotaljobs()
            localStorage.setItem('id_token_portal', res.data.token.token)
            // this.gettotaljobsbitrix()
            this.loading = false
            this.isvalidcvr = res.data.spa.IS_VALID_CVR
            if (this.isvalidcvr === '') {
              this.showcvr = true
              this.cvrerror = res.data.spa.VALID_CVR_REASON
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    decode () {
      this.loading = true
      this.loadingjobs = true
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/integration/decode/' + this.pid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            if (res.data === '') {
              this.showpopuperror()
            }
            this.cvrid = res.data
            if (this.cvrid !== '') {
              this.onlineSignupIntegration()
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>
<style>
/* start of v2 */
#payments___BV_modal_content_ {
  width: 1000px;
  height: inherit;  
}
#payments .modal-dialog {
  margin-left: 23%;
  margin-top: 7%;
}
#confirmcvr___BV_modal_content_ {
  width: 650px;
  height: inherit;  
}
#confirmcvr .modal-dialog {
  margin-left: 30%;
  margin-top: 7%;
}
#leverrsubmargin {
  width:200px;
}
#leverantext {
  text-align: -webkit-left;
}
#leveran .el-form-item__label {
  width:200px;
}
#leveran .el-form-item__content {
  width:100%;
}
#leveran .el-form-item__error{
  padding: 0px;
}
#leveran .el-form--label-top .el-form-item__label {
  padding: 0px;
}
#reepaycheckbox input[type="radio"] {
    height: 20px;
    width: 20px;
}
#leverandcheckbox input[type="radio"] {
    height: 20px;
    width: 20px;
}
#reminderbar {
    margin-top: 115px;
    position: fixed;
    z-index: 100;
}
/* end of v2 */
#signuppage * {
  font-family:'Noto-Sans', sans-serif;
}
#sendingsuccess___BV_modal_content_{
  margin-top: 25%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Hide scrollbar for Chrome, Safari and Opera */
#partnerloginapp::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
#partnerloginapp {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
input[type=number]::-webkit-outer-spin-button { 
	-webkit-appearance: none;
}
#subicons {
  border-radius: 50%;
  width: 117px;
  height: 117px;
  top: -13%;
  left: 130px;
  z-index: 100;
}
.second-secondary2 {
  color: #409EFF;
}
#popupcontract .modal-dialog {
      max-width: 80%;
      margin: 0px;
      padding: 0px;
      height: 80%;
  }
  #popupcontract___BV_modal_content_, #popupcontract___BV_modal_content_{
    max-width: 80%;
    margin: 0px;
    height: 80%;
    margin-top:10%;
    margin-left:20%;
  }
  #popuplink .modal-dialog {
      max-width: 80%;
      margin: 0px;
      padding: 0px;
      height: 80%;
  }
  #popuplink___BV_modal_content_, #popuplink__BV_modal_content_{
    max-width: 80%;
    margin: 0px;
    height: 80%;
    margin-top:10%;
    margin-left:20%;
  }
  #popuplinklever .modal-dialog {
      max-width: 80%;
      margin: 0px;
      padding: 0px;
      height: 80%;
  }
  #popuplinklever___BV_modal_content_, #popuplinklever__BV_modal_content_{
    max-width: 80%;
    margin: 0px;
    height: 80%;
    margin-top:10%;
    margin-left:20%;
  }
#marketplace2 {
  margin-top:120px;
}

#mainbarstatus {
  height: 60px;
  margin-top:55px;
  background: #fafafa;
  box-shadow:0 3px 10px rgb(0 0 0 / 10%);
}

#sendingsuccess .modal-dialog {
  max-width: 650px;
}
#payments .custom-control{
  display: block;
  padding-left:0;
}
#sendingsuccess .modal {
    background-image: url(/static/img/marketplace.webp);
    background-size: cover;
}
#confirmcvr .el-form-item__label {
  line-height: 0;
}
#confirmcvr .el-form-item {
  margin-bottom: 20px;
}
.buttonsticky {
  position: fixed;
  z-index: 1020;
  width: 100%;
  background-color: #ffffff;
  bottom: 0;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.package-popup {
  text-align: left;
}
.list-sub-text {
  font-size: 14px;
}
.disabled {
  pointer-events: none;
}
#rp-card-button .config-pay-button:enabled {
    background-color: #4dcf55!important;
    border: 1px solid #4dcf55;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
}
.navbarsignup {
  height: 55px;
  background-color: #fff;
  border-bottom: 1px solid #d1d4d7;
}
#confirmcvr .el-input__inner {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #00000008;
  border: 0px solid #23a3c03b;
  border-radius: 0px;
  color: #23A3C0;
}
#confirmcvr .el-input__inner {
  color: #23A3C0!important;
  font-size: 16px!important;
}
#confirmcvr .label {
  margin-bottom: 0px!important;
}
#confirmcvr .el-form-item__label {
  padding: 0;
  margin-bottom: 10px;
}
.app-footer.no-button {
  justify-content: center!important;
}
#subitemitem1 {
  height: 370px;
}
@media (max-width:27em) {
  #payment .payments {
    scroll-behavior: smooth
  }
  #payments .modal-dialog {
    margin-left: 3%;
    margin-top: 10%;
  }
  #confirmcvr___BV_modal_content_ {
    width: inherit;
  }
  #payments___BV_modal_content_ {
    width: inherit;
  }
  #confirmcvr .modal-dialog {
    margin-left: 3%;
    margin-top: 10%;
  }
  #reminderbar {
    margin-top: 125px;
  }
  #subicons {
    top: -25%;
  }
  #leveran .el-form-item__label {
    width: 100%;
    margin-bottom: 0px;
  }
  #levera .label {
    margin-bottom: 0px;
  }
  #leveran .el-form-item {
    margin-bottom: 15px ;
  }
  #leveran .el-checkbox__label {
    padding-left: 5px;
    text-align: initial;
  }
  #leveran .el-checkbox, .el-checkbox__input {
    display: flex;
    padding-top: 2px;
    white-space: initial;
  }
  #subitemitem1 {
    height: 290px;
  }
  .mmt4 {
    margin-top: 4rem;
  }
  .mp0 {
    padding: 0;
  }
  .app-header {
    padding-left: .2rem;
    padding-right: .2rem;
  }
  .mm0 {
    margin: 0px;
  }
  .mmx-auto {
    margin-left: auto;
    -webkit-box-pack: center;
    justify-content: center;
  }
  .mmb5 {
    margin-bottom: 5rem;
  }
  .mpt1 {
    padding-top: .5rem;
  }
  #popupcontract .modal-dialog {
      max-width: 90%!important;
      margin: 0px;
      padding: 0px;
      height: 90%!important;
  }
  #popupcontract___BV_modal_content_, #popupcontract___BV_modal_content_{
    max-width: 90%!important;
    margin: 0px;
    height: 90%!important;
    margin-top: 10%;
    margin-left: 10%;
  }
  #popuplink .modal-dialog {
      max-width: 90%!important;
      margin: 0px;
      padding: 0px;
      height: 90%!important;
  }
  #popuplink___BV_modal_content_, #popuplink__BV_modal_content_{
    max-width: 90%!important;
    margin: 0px;
    height: 90%!important;
    margin-top: 10%;
    margin-left: 10%;
  }
  #popuplinklever .modal-dialog {
      max-width: 90%!important;
      margin: 0px;
      padding: 0px;
      height: 90%!important;
  }
  #popuplinklever___BV_modal_content_, #popuplinklever__BV_modal_content_{
    max-width: 90%!important;
    margin: 0px;
    height: 90%!important;
    margin-top: 10%;
    margin-left: 10%;
  }
  .sm-hide {
    display: none;
  }
  .mobile-flex-column {
    flex-direction: column!important;
    align-items: center;
  }
  .sm-col-11 {
    width: 90%;
  }
  .sm-col-12 {
    width: 100%;
  }
  #confirmcvr .el-form-item__content {
    margin-right: 0;
  }
  #payments .custom-control {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
  }
  #mainbarstatus {
    height:70px
  }
  #payments .custom-control-label {
    margin: 0;
    font-size: 12px;
  }
  #payments .label {
    margin-bottom: 0;
  }
  .text-secondary {
    font-size: 12px;
  }
}
#payments .el-popover__reference {
    position: absolute;
    right: 0;
    top: 0;
}
#payments ul.list-image-check-mintgreen li:before {
    content: '';
}
#payments ul {
    list-style-type: none;
    list-style-position: outside;
    padding-left: 1rem;
}
#payments ol, ul {
    list-style: none;
}
#payments ul.list-image-check-mintgreen li.empty:before {
    width: 12px;
    height: 3px;
    position: relative;
    background: #003645;
    content: ' ';
    display: inline-block;
}
#payments ul.list-image-check-mintgreen li {
    position: relative;
    padding-left: 1.8em;
}
#payments ul.list-image-check-mintgreen li:before {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    background: url(https://www.haandvaerker.dk/imgs/check-mintgreen.svg) center center no-repeat;
    background-size: contain
}
#payments ul.list-image-check-mintgreen li.empty {
    text-align: center!important;
    padding-left: 0!important;
    padding-right: 0!important;
}
.dg-content{
  white-space:pre-wrap;
}
.custom-control-input {
      position: unset;
    z-index: 1;
    opacity: 1;
    margin-right: 14px;
}
.image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
.field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}

.greenblue-button {
    color: #fff;
    background-color: rgba(77, 207, 85, 1.0);
    border: 0;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
.dg-content{
  white-space:pre-wrap;
}
.container {
  padding:0;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.modal-footer,
.modal-header {
  padding: 0;
}
.modal-header,
.modal-footer {
  border-bottom: 0;
  border-top: 0;
}
.modal-backdrop.show {
  opacity: 0.8;
  background-color: rgba(44, 62, 80, 0.975);
}
.modal-body-marketplace {
  padding: 0!important;
}
.modal-footer > div {
  width: 100%;
}
#payments .modal-body{
  padding: 20px!important;
}
</style>



// WEBPACK FOOTER //
// demov2.vue?2881aea7